module.exports = __webpack_public_path__ + "static/media/basketballStrike.218af3fe.png";